import React, { useEffect, useImperativeHandle, useRef } from "react";
import isBlank from "@sedan-utils/is-blank";
import { NodesUtil } from "../NodesUtil";
import { BlankV2 } from "../Blank/BlankV2";
import style from "./CustomJsFunction.module.css";
import { isObject } from "lodash";
export var CustomJsFunction = /*#__PURE__*/React.forwardRef(function (props, customJsFunctionRef) {
  var iframeCustomJsFunctionRef = useRef(null);
  var iframe = useRef(null);
  var injectHtml = function injectHtml(htmlStr) {
    var _htmlStr$type, _iframe$current, _iframe$current2, _iframedoc$body, _iframedoc$body2;
    var htmlValue = isObject(htmlStr) ? htmlStr.value || "" : htmlStr;
    console.log("jj htmlStr", htmlStr);

    // 处理蛋白质显示
    if (isObject(htmlStr) && ((_htmlStr$type = htmlStr.type) === null || _htmlStr$type === void 0 ? void 0 : _htmlStr$type.toLocaleLowerCase()) === "protein") {
      var proteinValue = htmlStr.value;
      htmlValue = "<!DOCTYPE html>\n      <html>\n        <head>\n          <link href=\"https://cdn.jsdelivr.net/npm/molstar@3.31.3/build/viewer/molstar.min.css\" rel=\"stylesheet\">\n          <script src=\"https://cdn.jsdelivr.net/npm/molstar@3.31.3/build/viewer/molstar.min.js\"></script>\n        </head>\n        <body>\n        <div id=\"molstar_content\"></div>\n        </body>\n        <script>\n          molstar.Viewer.create('molstar_content', {\n            layoutShowControls: false,\n          }).then(viewer => {\n            var structureUrl = 'https://alphafold.ebi.ac.uk/files/".concat(proteinValue, "-model_v4.cif';\n            if (structureUrl) viewer.loadStructureFromUrl(structureUrl, 'mmcif', false);\n          });\n        </script>\n      </html>\n    ");
    }
    var iframedoc = ((_iframe$current = iframe.current) === null || _iframe$current === void 0 ? void 0 : _iframe$current.contentDocument) || ((_iframe$current2 = iframe.current) === null || _iframe$current2 === void 0 || (_iframe$current2 = _iframe$current2.contentWindow) === null || _iframe$current2 === void 0 ? void 0 : _iframe$current2.document);
    if (iframedoc) {
      iframedoc.open();
      iframedoc.writeln(htmlValue);
      iframedoc.close();
    } else {
      NodesUtil.message({
        content: "Unable to render html code",
        type: "warning"
      });
      return;
    }
    if (!iframe.current) {
      return;
    }
    var bodyScrollHeight = iframedoc === null || iframedoc === void 0 || (_iframedoc$body = iframedoc.body) === null || _iframedoc$body === void 0 ? void 0 : _iframedoc$body.scrollHeight;
    var bodyClientHeight = iframedoc === null || iframedoc === void 0 || (_iframedoc$body2 = iframedoc.body) === null || _iframedoc$body2 === void 0 ? void 0 : _iframedoc$body2.clientHeight;
    var minHeight = !isBlank(props.parentNodeId) ? 270 : 300;
    // 可滚动高度大于可视高度，并且大于最小高度 minHeight
    if (bodyScrollHeight > bodyClientHeight && bodyScrollHeight > minHeight) {
      iframe.current.style.minHeight = "".concat(bodyClientHeight > 800 ? 800 : bodyScrollHeight, "px");
    } else {
      iframe.current.style.minHeight = "".concat(minHeight, "px");
    }
  };

  // 暴露子组件方法
  useImperativeHandle(customJsFunctionRef, function () {
    return {
      injectHtml: injectHtml
    };
  });
  var projectProteinModel = props.textAreaValue;
  useEffect(function () {
    if (!projectProteinModel.loading && projectProteinModel.value) {
      injectHtml(projectProteinModel);
    }
  }, [projectProteinModel.value, projectProteinModel.loading]);
  if (isBlank(projectProteinModel)) {
    return /*#__PURE__*/React.createElement(BlankV2, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "CustomJsFunction",
    className: style["white-frame"],
    style: {
      minWidth: "".concat(!isBlank(props.parentNodeId) ? "unset" : "320px"),
      minHeight: "".concat(!isBlank(props.parentNodeId) ? "unset" : "370px")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style["customJsFunc-box"]
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["customJsFunc-content"]),
    ref: iframeCustomJsFunctionRef,
    style: {
      minWidth: "".concat(!isBlank(props.parentNodeId) ? "unset" : "300px"),
      minHeight: "".concat(!isBlank(props.parentNodeId) ? "unset" : "300px")
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    className: style.customJsIframe,
    ref: iframe
  }))));
});